export { default } from './SWContentBlockWithVideo';
